import styles from "./index.module.css";
import VisualizerBanner from "../visualizer-banner";

export default function LatestUpdates() {
	return (
		<div className={styles.latestUpdatesPage}>
			<div className={styles.latestUpdatesContainer}>
				<div className={styles.bannerContainer}>
					<VisualizerBanner />
				</div>
				<iframe
					id="verityLatestUpdatesIframe"
					title="Verity Updates"
					allow="fullscreen; encrypted-media"
					src="https://www.yuja.com/updates-m/?show=verity"
					className={styles.latestUpdates}
					allowFullScreen
				/>
			</div>
		</div>
	);
}
